import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-regular.css";
import { ButtonLink } from "../../components/buttons/button-link.tsx";
import { usePropertyDetailsContext } from "../contexts/property-details-context.tsx";
import { ComponentProps } from "react";

type BookingButtonProps = Omit<ComponentProps<"a">, "href" | "children">;

export const BookingButton = ({ className, ...rest }: BookingButtonProps) => {
  const { propertyId, rental, agentEmail, displayAddress } = usePropertyDetailsContext();

  const href =
    rental && agentEmail
      ? `mailto:${agentEmail}?subject=${displayAddress ?? ""} (espc.com)`
      : propertyId
        ? `/property/viewing?propertyId=${propertyId.toString()}`
        : "/property/viewing";

  return (
    <ButtonLink
      label="Book a viewing"
      colorVariant="secondary"
      variant="solid"
      href={href}
      className={className}
      renderLeadingIcon={() => <i aria-hidden="true" className="fa-sharp fa-regular fa-calendar-clock" />}
      {...rest}
    />
  );
};
